import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";

const $dnkMenu = $('#dnk-menu');
const tl_mobileMenu = new TimelineMax({paused:true, reversed:true});

$dnkMenu.on('click', function() {

  if ( $(this).hasClass('closed') ) {
    
    $(this).removeClass('closed').addClass('open')

    $('body').css({'overflow': 'hidden'})

  } else if ( $(this).hasClass('open') ) {

    $(this).removeClass('open').addClass('closed')

    $('body').css({'overflow': 'visible'})

  }

  tl_mobileMenu.reversed() ? tl_mobileMenu.play() : tl_mobileMenu.reverse(); 
});

const animation = (tl_mobileMenu) => {
  tl_mobileMenu.to('#dnk-menu__bottom', 0.3, {y: -14, autoAlpha: 0, ease: Power2.easeOut})

  tl_mobileMenu.to('#mobileMenu', 0.3, {x: 0, ease: Power2.easeOut})

  tl_mobileMenu.staggerFrom('#mobileMenu nav a', 0.3, {
    autoAlpha: 0,
    x: -20,
    ease: Power2.easeOut
  }, 0.06);
}

animation(tl_mobileMenu)


